import {
  type THeadersGetterArg,
  startHeadersInterceptor,
} from "@kode-frontend/session-interceptor";
import { type AxiosInstance } from "axios";

import { $session } from "@entities/session";

const getHeaders = (_arg: THeadersGetterArg) => {
  const { accessToken } = $session.getState();

  const headers = []; // TOOD: add headers from axios and exclude Authorization

  if (accessToken) {
    headers.push({
      key: "Authorization",
      value: `Bearer ${accessToken}`,
    });
  }

  return headers;
};

export const addAccessTokenToRequests = (axiosInstance: AxiosInstance) => {
  startHeadersInterceptor({
    getHeaders,
  })([axiosInstance]);
};
